const actions = {
  GET_TRANSFERS: 'GET_TRANSFERS',
  SET_TRANSFERS: 'SET_TRANSFERS',
  GET_TRANSFERS_BEGIN: 'GET_TRANSFERS_BEGIN',
  GET_TRANSFERS_FINISH: 'GET_TRANSFERS_FINISH',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  CREATE_TRANSFER: 'CREATE_TRANSFER',
  APPROVE_TRANSFER: 'APPROVE_TRANSFER',
  REJECT_TRANSFER: 'REJECT_TRANSFER',

  getTransfers: () => ({
    type: actions.GET_TRANSFERS,
  }),

  setTransfers: (data: any) => ({
    type: actions.SET_TRANSFERS,
    data,
  }),

  getTransfersBegin: () => ({
    type: actions.GET_TRANSFERS_BEGIN,
  }),

  getTransfersFinish: () => ({
    type: actions.GET_TRANSFERS_FINISH,
  }),

  setCurrentPage: (page: number) => ({
    type: actions.SET_CURRENT_PAGE,
    page,
  }),

  createTransfer: (transfer: any) => ({
    type: actions.CREATE_TRANSFER,
    transfer,
  }),

  approveTransfer: (transferId: string) => ({
    type: actions.APPROVE_TRANSFER,
    transferId,
  }),

  rejectTransfer: (transferId: string) => ({
    type: actions.REJECT_TRANSFER,
    transferId,
  }),
};

export default actions;

